import { Turbo } from "@hotwired/turbo-rails"
import { Modal, Offcanvas } from 'bootstrap'

Turbo.StreamActions.hide_modal = function() {
  document.querySelectorAll('.modal.show').forEach(modalEl => {
    const modal = Modal.getInstance(modalEl)
    if (modal) modal.hide()
  })

  document.querySelectorAll('.modal-backdrop').forEach(el => el.remove())
  document.body.classList.remove('modal-open')
  document.body.style.removeProperty('overflow')
  document.body.style.removeProperty('padding-right')
}

Turbo.StreamActions.show_offcanvas = function() {
  const offcanvasEl = document.getElementById(this.target)
  if (!offcanvasEl) return

  const offcanvas = Offcanvas.getOrCreateInstance(offcanvasEl)
  offcanvas.show()
}

Turbo.StreamActions.hide_offcanvas = function() {
  document.querySelectorAll('.offcanvas.show').forEach(offcanvasEl => {
    const offcanvas = Offcanvas.getInstance(offcanvasEl)
    if (offcanvas) offcanvas.hide()
  })
}

